// Import routes
import OperatorRoutes from './OperatorRoutes';
import RetailRoutes from './RetailRoutes';

// Import helpers
import { isRetail } from 'helpers/operators';

const AppRoutes = () => (isRetail ? <RetailRoutes /> : <OperatorRoutes />);

export default AppRoutes;
